/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import InvestmentStyleDiagnosisAnxietyScore from './InvestmentStyleDiagnosisAnxietyScore';
import InvestmentStyleDiagnosisInterestScore from './InvestmentStyleDiagnosisInterestScore';
import InvestmentStyleDiagnosisMeetingQuestion from './InvestmentStyleDiagnosisMeetingQuestion';

/**
 * The InvestmentStyleDiagnosisResult model module.
 * @module model/InvestmentStyleDiagnosisResult
 * @version 1.0.0
 */
class InvestmentStyleDiagnosisResult {
    /**
     * Constructs a new <code>InvestmentStyleDiagnosisResult</code>.
     * 各閲覧先で共通の診断結果・ID・作成日時。
     * @alias module:model/InvestmentStyleDiagnosisResult
     */
    constructor() { 
        
        InvestmentStyleDiagnosisResult.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>InvestmentStyleDiagnosisResult</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvestmentStyleDiagnosisResult} obj Optional instance to populate.
     * @return {module:model/InvestmentStyleDiagnosisResult} The populated <code>InvestmentStyleDiagnosisResult</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvestmentStyleDiagnosisResult();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('customer_type')) {
                obj['customer_type'] = ApiClient.convertToType(data['customer_type'], 'String');
            }
            if (data.hasOwnProperty('core_goal')) {
                obj['core_goal'] = ApiClient.convertToType(data['core_goal'], 'String');
            }
            if (data.hasOwnProperty('interest_scores')) {
                obj['interest_scores'] = ApiClient.convertToType(data['interest_scores'], [InvestmentStyleDiagnosisInterestScore]);
            }
            if (data.hasOwnProperty('suited_assets')) {
                obj['suited_assets'] = ApiClient.convertToType(data['suited_assets'], ['String']);
            }
            if (data.hasOwnProperty('meeting_questions')) {
                obj['meeting_questions'] = ApiClient.convertToType(data['meeting_questions'], [InvestmentStyleDiagnosisMeetingQuestion]);
            }
            if (data.hasOwnProperty('anxiety_scores')) {
                obj['anxiety_scores'] = ApiClient.convertToType(data['anxiety_scores'], [InvestmentStyleDiagnosisAnxietyScore]);
            }
            if (data.hasOwnProperty('avoid_sales_style_warnings')) {
                obj['avoid_sales_style_warnings'] = ApiClient.convertToType(data['avoid_sales_style_warnings'], ['String']);
            }
            if (data.hasOwnProperty('needs_safety_content')) {
                obj['needs_safety_content'] = ApiClient.convertToType(data['needs_safety_content'], 'Boolean');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvestmentStyleDiagnosisResult</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvestmentStyleDiagnosisResult</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['customer_type'] && !(typeof data['customer_type'] === 'string' || data['customer_type'] instanceof String)) {
            throw new Error("Expected the field `customer_type` to be a primitive type in the JSON string but got " + data['customer_type']);
        }
        // ensure the json data is a string
        if (data['core_goal'] && !(typeof data['core_goal'] === 'string' || data['core_goal'] instanceof String)) {
            throw new Error("Expected the field `core_goal` to be a primitive type in the JSON string but got " + data['core_goal']);
        }
        if (data['interest_scores']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['interest_scores'])) {
                throw new Error("Expected the field `interest_scores` to be an array in the JSON data but got " + data['interest_scores']);
            }
            // validate the optional field `interest_scores` (array)
            for (const item of data['interest_scores']) {
                InvestmentStyleDiagnosisInterestScore.validateJSON(item);
            };
        }
        // ensure the json data is an array
        if (!Array.isArray(data['suited_assets'])) {
            throw new Error("Expected the field `suited_assets` to be an array in the JSON data but got " + data['suited_assets']);
        }
        if (data['meeting_questions']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['meeting_questions'])) {
                throw new Error("Expected the field `meeting_questions` to be an array in the JSON data but got " + data['meeting_questions']);
            }
            // validate the optional field `meeting_questions` (array)
            for (const item of data['meeting_questions']) {
                InvestmentStyleDiagnosisMeetingQuestion.validateJSON(item);
            };
        }
        if (data['anxiety_scores']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['anxiety_scores'])) {
                throw new Error("Expected the field `anxiety_scores` to be an array in the JSON data but got " + data['anxiety_scores']);
            }
            // validate the optional field `anxiety_scores` (array)
            for (const item of data['anxiety_scores']) {
                InvestmentStyleDiagnosisAnxietyScore.validateJSON(item);
            };
        }
        // ensure the json data is an array
        if (!Array.isArray(data['avoid_sales_style_warnings'])) {
            throw new Error("Expected the field `avoid_sales_style_warnings` to be an array in the JSON data but got " + data['avoid_sales_style_warnings']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
InvestmentStyleDiagnosisResult.prototype['id'] = undefined;

/**
 * お客様タイプ
 * @member {module:model/InvestmentStyleDiagnosisResult.CustomerTypeEnum} customer_type
 */
InvestmentStyleDiagnosisResult.prototype['customer_type'] = undefined;

/**
 * 診断から導出した中心的な投資目的
 * @member {module:model/InvestmentStyleDiagnosisResult.CoreGoalEnum} core_goal
 */
InvestmentStyleDiagnosisResult.prototype['core_goal'] = undefined;

/**
 * 関心グラフ（スコア降順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisInterestScore>} interest_scores
 */
InvestmentStyleDiagnosisResult.prototype['interest_scores'] = undefined;

/**
 * 向いているアセット（おすすめ順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisResult.SuitedAssetsEnum>} suited_assets
 */
InvestmentStyleDiagnosisResult.prototype['suited_assets'] = undefined;

/**
 * 面談で聞くと良い質問（最大5件・表示順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisMeetingQuestion>} meeting_questions
 */
InvestmentStyleDiagnosisResult.prototype['meeting_questions'] = undefined;

/**
 * 不安項目（降順）
 * @member {Array.<module:model/InvestmentStyleDiagnosisAnxietyScore>} anxiety_scores
 */
InvestmentStyleDiagnosisResult.prototype['anxiety_scores'] = undefined;

/**
 * 避けるべき進め方の警告（重要度順・最大2件）
 * @member {Array.<module:model/InvestmentStyleDiagnosisResult.AvoidSalesStyleWarningsEnum>} avoid_sales_style_warnings
 */
InvestmentStyleDiagnosisResult.prototype['avoid_sales_style_warnings'] = undefined;

/**
 * 安全装置フラグ（強い不安が3つ以上）
 * @member {Boolean} needs_safety_content
 */
InvestmentStyleDiagnosisResult.prototype['needs_safety_content'] = undefined;

/**
 * 診断完了日時（作成日時）
 * @member {Date} created_at
 */
InvestmentStyleDiagnosisResult.prototype['created_at'] = undefined;





/**
 * Allowed values for the <code>customer_type</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisResult['CustomerTypeEnum'] = {

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain",

    /**
     * value: "long_term_hold"
     * @const
     */
    "long_term_hold": "long_term_hold",

    /**
     * value: "location_focused"
     * @const
     */
    "location_focused": "location_focused",

    /**
     * value: "yield_focused"
     * @const
     */
    "yield_focused": "yield_focused"
};


/**
 * Allowed values for the <code>core_goal</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisResult['CoreGoalEnum'] = {

    /**
     * value: "retirement_income"
     * @const
     */
    "retirement_income": "retirement_income",

    /**
     * value: "long_term_asset"
     * @const
     */
    "long_term_asset": "long_term_asset",

    /**
     * value: "family_protection"
     * @const
     */
    "family_protection": "family_protection",

    /**
     * value: "side_income"
     * @const
     */
    "side_income": "side_income",

    /**
     * value: "low_effort"
     * @const
     */
    "low_effort": "low_effort",

    /**
     * value: "yield_improvement"
     * @const
     */
    "yield_improvement": "yield_improvement",

    /**
     * value: "loss_avoidance"
     * @const
     */
    "loss_avoidance": "loss_avoidance",

    /**
     * value: "short_term_gain"
     * @const
     */
    "short_term_gain": "short_term_gain"
};


/**
 * Allowed values for the <code>suitedAssets</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisResult['SuitedAssetsEnum'] = {

    /**
     * value: "urban_used_kubun"
     * @const
     */
    "urban_used_kubun": "urban_used_kubun",

    /**
     * value: "new_kubun"
     * @const
     */
    "new_kubun": "new_kubun",

    /**
     * value: "renovated_kubun"
     * @const
     */
    "renovated_kubun": "renovated_kubun",

    /**
     * value: "urban_old_ittou"
     * @const
     */
    "urban_old_ittou": "urban_old_ittou",

    /**
     * value: "urban_new_ittou"
     * @const
     */
    "urban_new_ittou": "urban_new_ittou",

    /**
     * value: "rural_old_ittou"
     * @const
     */
    "rural_old_ittou": "rural_old_ittou",

    /**
     * value: "rural_new_ittou"
     * @const
     */
    "rural_new_ittou": "rural_new_ittou"
};


/**
 * Allowed values for the <code>avoidSalesStyleWarnings</code> property.
 * @enum {String}
 * @readonly
 */
InvestmentStyleDiagnosisResult['AvoidSalesStyleWarningsEnum'] = {

    /**
     * value: "overpriced"
     * @const
     */
    "overpriced": "overpriced",

    /**
     * value: "tax_only"
     * @const
     */
    "tax_only": "tax_only",

    /**
     * value: "pushy_immediate"
     * @const
     */
    "pushy_immediate": "pushy_immediate",

    /**
     * value: "high_management"
     * @const
     */
    "high_management": "high_management",

    /**
     * value: "excessive_loan"
     * @const
     */
    "excessive_loan": "excessive_loan"
};



export default InvestmentStyleDiagnosisResult;

